export default {"src":"/_next/static/image/public/images/flags/flag_82.2da7aa0017ecdc4deefb8422ee691920.svg","height":16,"width":24};